/* YP homepage behaviours (2026-10-24, starchive-structured homepage).
   Progressive enhancement only: every link, card and photo is server-rendered; this file
   adds the progress hairlines, arrow paging, the mobile story flip, the concierge slide
   counter, the hero poster fade and the transparent-over-hero header.
   Contract (data attributes):
     [data-yp-scope]        container that owns one track + its controls
     [data-yp-track]        horizontal scroll-snap track (ul)
     [data-yp-bar] > i      progress hairline thumb
     [data-yp-arr="-1|1"]   page buttons
     [data-yp-count]        "current slide" number (concierge)
     [data-yp-flip]         story wrapper; [data-yp-flip-front] photo link, [data-yp-flip-back] BACK button,
                            [data-yp-flip-nav] element inside the front face that must navigate (SHOP NOW)
     [data-yp-hero]         hero section; [data-yp-hero-frame] the frame observed for the overlay header */
(function () {
  if (window.__ypHome) return;
  window.__ypHome = true;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function initTrack(trk) {
    if (trk.dataset.ypInit) return;
    trk.dataset.ypInit = '1';
    var scope = trk.closest('[data-yp-scope]') || trk.parentElement;
    var bar = scope.querySelector('[data-yp-bar] i');
    var prev = scope.querySelector('[data-yp-arr="-1"]');
    var next = scope.querySelector('[data-yp-arr="1"]');
    var count = scope.querySelector('[data-yp-count]');
    var raf = 0;
    function update() {
      raf = 0;
      var sw = trk.scrollWidth, cw = trk.clientWidth, sl = trk.scrollLeft;
      if (!cw) return;
      if (bar) {
        var f = Math.min(1, cw / sw);
        bar.style.width = (f * 100) + '%';
        bar.style.transform = 'translateX(' + (sl / cw * 100) + '%)';
      }
      scope.classList.toggle('yp-static', sw <= cw + 1);
      if (prev) prev.disabled = sl <= 1;
      if (next) next.disabled = sl + cw >= sw - 1;
      if (count) count.textContent = Math.round(sl / cw) + 1;
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    trk.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(trk);
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-yp-arr'), 10) || 1;
        trk.scrollBy({ left: dir * trk.clientWidth, behavior: 'smooth' });
      });
    });
    update();
  }

  function initFlip(wrap) {
    if (wrap.dataset.ypInit) return;
    wrap.dataset.ypInit = '1';
    var story = wrap.closest('.yp-story');
    var front = wrap.querySelector('[data-yp-flip-front]');
    var back = wrap.querySelector('[data-yp-flip-back]');
    var side = wrap.querySelector('.yp-story__side');
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!story || !front || !side) return;
    if (story.classList.contains('yp-story--noflip')) return; // photo is a plain link when the flip is off
    front.addEventListener('click', function (e) {
      if (!mq.matches) return;                       // desktop: the photo is a plain link
      if (e.target.closest('[data-yp-flip-nav]')) return; // SHOP NOW keeps navigating
      e.preventDefault();
      story.classList.add('is-flipped');
      if (reduce.matches) story.classList.add('is-settled');
      side.setAttribute('aria-hidden', 'false');
    });
    if (back) back.addEventListener('click', function () {
      story.classList.remove('is-flipped', 'is-settled');
      side.setAttribute('aria-hidden', mq.matches ? 'true' : 'false');
    });
    side.addEventListener('transitionend', function (e) {
      if (e.target !== side || e.propertyName !== 'transform') return;
      if (story.classList.contains('is-flipped')) story.classList.add('is-settled');
    });
    function syncAria() { side.setAttribute('aria-hidden', mq.matches && !story.classList.contains('is-flipped') ? 'true' : 'false'); }
    mq.addEventListener ? mq.addEventListener('change', syncAria) : mq.addListener(syncAria);
    syncAria();
  }

  function initHero(hero) {
    if (hero.dataset.ypInit) return;
    hero.dataset.ypInit = '1';
    var video = hero.querySelector('video');
    if (video) {
      video.muted = true;
      var mark = function () { hero.classList.add('yp-playing'); };
      video.addEventListener('playing', mark);
      if (!video.paused && video.readyState > 2) mark();
      try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (err) {}
    }
    if (hero.classList.contains('yp-hero--overlay')) {
      var frame = hero.querySelector('[data-yp-hero-frame]') || hero;
      var pending = 0;
      var hw = document.querySelector('.header-wrapper');
      var check = function () {
        pending = 0;
        if (hw) { var real = Math.round(hw.getBoundingClientRect().height); if (real > 40) document.documentElement.style.setProperty('--yp-hh', real + 'px'); }
        var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--yp-hh'), 10) || 88;
        var r = frame.getBoundingClientRect();
        document.body.classList.toggle('yp-ov', r.bottom > hh && r.top < hh);
      };
      var ask = function () { if (!pending) pending = requestAnimationFrame(check); };
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', ask);
      window.addEventListener('load', ask);
      check();
    }
  }

  // Light card (2026-10-25, snippets/card-product-light.liquid): photo 2 carries data-src only and is
  // fetched on a card's first hover, never before; once it has loaded the well is marked ready and the
  // CSS in component-card.css cross-fades it in. Desktop pointers only (phones have no hover and no strip).
  function initLightCards() {
    if (document.__ypLc) return;
    document.__ypLc = true;
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var w = e.target && e.target.closest ? e.target.closest('.card-wrapper') : null;
      if (!w) return;
      var img = w.querySelector('.yp-lc__i2[data-src]');
      if (!img) return;
      var well = img.closest('.yp-lc');
      img.addEventListener('load', function () { if (well) well.classList.add('yp-lc--ready'); }, { once: true });
      if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
      img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }, { passive: true });
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-yp-track]').forEach(initTrack);
    root.querySelectorAll('[data-yp-flip]').forEach(initFlip);
    root.querySelectorAll('[data-yp-hero]').forEach(initHero);
    initLightCards();
  }

  ready(function () { initAll(); });
  // Theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
